<template>
    <div class="d-flex flex-column fill-height" id="statistics">
        <v-row ref="headerFilters" class="flex-grow-0">
            <data-table-filters v-if="!isMobile"
                name="Estatísticas - Consumos"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="schema"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh(true)"
                @clear-filters="onClearFilters()"
                @operator-changed="changeCurrentOperator($event)"
                showOperatorSelection
                changeViewTypeEnabled
                :operatorType="currentOperator"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    name="Estatísticas - Consumos"
                    :isConsumptions="true"
                    :has-active-filters="hasActiveFilters"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    :filters="filters"
                    :schema="schema"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh(true)"
                    @clear-filters="onClearFilters()"
                    @operator-changed="changeCurrentOperator($event)"
                    showOperatorSelection
                    changeViewTypeEnabled
                    :operatorType="currentOperator"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col>
                <portal to="v-form-base">
                    <v-form-base :model="filters" :schema="schema" @input="onFiltersChanged"></v-form-base>
                </portal>

                <app-card class="d-flex flex-column align-stretch fill-height py-4 px-4">
                    <template v-slot:image>
                        <div class="d-flex justify-center">
                            <v-tabs show-arrows centered id="myprovet-tabs" v-model="selectedTabIndex" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" style="border-radius: 8px; padding-left: 11px">
                                <v-tabs-slider color="#154579"></v-tabs-slider>

                                <v-tab class="myprovet-tab-item" v-for="item in tabItems" :key="item.tab">
                                    {{ item.tab }}
                                </v-tab>
                            </v-tabs>
                        </div>

                        <loading-indicator v-if="showLoading" :no-data="activeChartNoData" :loading="showLoading"> </loading-indicator>

                        <template v-else-if="selectedTabIndex === 0">
                            <div class="mt-4 fill-height  fill-height-c">
                                <div class="fill-height" style="float: left;  width: 100%;">
                                    <area-chart title="Estatísticas de consumos" :height="isMobile?'520px':'420px'" :subtitle="'Total Valores Período: '+summaryTotalValue "  class="fill-height" curve="straight" isPriceChart :series="summary"></area-chart>
                                </div>
                                <!--<div style="width: 180px; float: right">
                                    <div class="d-flex flex-column align-center">
                                        <span class="text-center consumptions-totals-title dark-blue-color">Totais</span>
                                        <div class="mt-7 text-center font-size-md">
                                            <span>Total Valores Período:</span><br />
                                            <span>{{ summaryTotalValue }} </span><br />
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                        </template>

                        <template v-else-if="selectedTabIndex === 1">
                            <div class="mt-4"></div>

                            <div class="fill-height fill-height-c">
                                <div class="d-flex fill-height justify-space-between" id="tab_content_performance">
                                    <div class="d-flex align-center">
                                        <v-btn :disabled="performance.currentPage === 1" icon elevation="1" class="mr-3 appbar-icon-button btn-bg-color-blue dark-blue-color" @click="changePerformancePage(-1)">
                                            <v-icon>mdi-arrow-left</v-icon>
                                        </v-btn>
                                    </div>

                                    <div v-if="!isMobile" class="d-flex flex-grow-1 flex-column align-center" :style="`overflow-y: auto; height: ${datatableSize}px`">
                                        <div  class="d-flex flex-column justify-center">
                                            <bar-chart
                                                :title="`TOP 10 ${chartName} por preço de compra (com rappel valorizado)`"
                                                toolbar
                                                horizontal
                                                hide-legend
                                                is-price-chart
                                                show-data-labels
                                                distributed
                                                :offset-x="55"
                                                :max-label-width="barLabelWidth"
                                                :series="getChartPriceSeries"
                                                height="320px"
                                                bar-height="40%"
                                                :width="barWidth"
                                                :divwidth="divwidth"
                                            ></bar-chart>
                                        </div>

                                        <div class="my-4"></div>

                                        <div class="d-flex flex-column justify-center">
                                            <bar-chart :divwidth="divwidth" :title="`TOP 10 ${chartName} por quantidade (com bónus)`" toolbar horizontal hide-legend show-data-labels distributed :offset-x="30" is-float :max-label-width="barLabelWidth" :series="getChartQuantitySeries" height="320px" bar-height="40%" :width="barWidth">
                                                <template #content>
                                                    <div class="text-caption font-size-xs text-center performance-info" style="width:100%;">
                                                        Nos Top 10 são apresentados apenas dados <b>POSITIVOS</b> descartando movimentos que tenham saldo negativo, pelo que a soma dos valores apresentados pode diferir dos Totais Compras.
                                                    </div>
                                                </template>
                                            </bar-chart>
                                        </div>
                                    </div>
                                    <div v-else class="d-flex flex-grow-1 flex-column align-center" :style="`overflow-y: auto;`">
                                        <div class="d-flex flex-column justify-center">
                                            <progress-chart
                                                :title="`TOP 10 ${chartName} por preço de compra (com rappel valorizado)`"
                                                :max-label-width="barLabelWidth"
                                                :series="getChartPriceSeries"
                                                height="320px"
                                                :width="barWidth"
                                            ></progress-chart>
                                        </div>

                                        <div class="my-4"></div>

                                        <div class="d-flex flex-column justify-center">

                                            <progress-chart
                                                :isQuantity="true"
                                                :title="`TOP 10 ${chartName} por quantidade (com bónus)`"
                                                :max-label-width="barLabelWidth"
                                                :series="getChartQuantitySeries"
                                                height="320px"
                                                :divwidth="divwidth"
                                            ></progress-chart>
                                        </div>
                                    </div>
                                    <div class="d-flex align-center">
                                        <v-btn :disabled="!hasMoreChartPages" icon elevation="1" class="ml-3 appbar-icon-button btn-bg-color-blue dark-blue-color" @click="changePerformancePage(1)">
                                            <v-icon>mdi-arrow-right</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-else-if="selectedTabIndex === 2">
                            <div class="mt-4"></div>

                            <pure-datatable
                                :key="selectedTabIndex"
                                ref="datatable_simplified"
                                endpoint="/api/statistics/consumptions/simplified_view"
                                @data-changed="dataChanged('datatable_simplified')"
                                :queryParams="queryParams"
                                v-slot:default="{ vOn, vBind, isLoading, setLocalOptions, setCurrentOperator, onChangeQueryBuilder }"
                            >
                                <v-data-table id="v_table_simplified_view"
                                    class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table"
                                    :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                    fixed-header
                                    multi-sort
                                    :headers="simplified_view_headers"
                                    :header-props="headerProps"
                                    :hide-default-headers="isMobile"
                                    @update:options="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                    v-on="vOn"
                                    v-bind="vBind"
                                    hide-default-footer
                                    no-data-text="Sem dados disponíveis."
                                    no-results-text="Não foram encontrados resultados."
                                    :loading="isMobile?isLoading:false"
                                    loading-text="A carregar dados..."
                                    :footer-props="{
                                        showFirstLastPage: false,
                                        itemsPerPageOptions: itemsPerPageOptions,
                                        itemsPerPageText: 'Registos por página',
                                    }"
                                >
                                    <template v-if="!isMobile"  #[`item.reference`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.reference }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.designation`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ item.designation }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.laboratory_name`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.laboratory_name }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.bonus_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.bonus_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.total_quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.total_quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.net_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.net_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.discount`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.discount) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile"  #[`item.gross_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.gross_total) }}
                                        </div>
                                    </template>
                                <template v-if="isMobile" v-slot:item="{ item, index }">
                                <tr>
                                    <v-card
                                        elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">

                                                <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-12 pt-0 pb-0 px-0">
                                                            <div class="pl-0 datatable-designation-text design">
                                                                {{ item.designation }}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                            <div class="pl-0 datatable-lable-text laboratory">
                                                                {{ item.laboratory_name}}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                            <div class="pl-0 datatable-lable-text code">
                                                                {{ item.reference}}
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                 <v-row class="d-flex align-start pt-0 pb-0 mt-2">
                                                    <v-col class="col col-6 px-0 pt-0 pb-0 wrap-l">
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">SUBTOTAL QTD.</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">SUBTOTAL QTD. BÓNUS</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">TOTAL QTD.</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">VAL. LIQ. COMPRA</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">RAPPEL</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">TOTAL C/ RAPPEL VALORIZADO</v-col>
                                                    </v-col>
                                                    <v-col class="col col-6  pt-0 pb-0 wrap-r">
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                <div class="datatable-designation-text">
                                                                        {{ formatQuantity(item.quantity) }}
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatQuantity(item.bonus_total)}}
                                                               </div>
                                                        </v-col>

                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatQuantity(item.total_quantity) }}
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatPrice(item.net_total) }}
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatPrice(item.discount) }}
                                                             </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                        {{ formatPrice(item.gross_total)}}
                                                             </div>
                                                        </v-col>

                                                    </v-col>
                                                 </v-row>
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </tr>
                             </template>
                                    <template v-slot:footer="scope">
                                        <div>
                                            <div class="datatable-footer-border"></div>

                                            <data-table-footer
                                                :showExport="canExportSimplified()"
                                                :scope="scope"
                                                @export="exportSimplifiedData"
                                                @updateOptions="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                                :showOrderButton="false"
                                                :isLoading="isLoading"
                                                style="height: fit-content"
                                            ></data-table-footer>
                                        </div>
                                    </template>
                                </v-data-table>
                            </pure-datatable>
                        </template>

                        <template v-else-if="selectedTabIndex === 3">
                            <div class="mt-4"></div>

                            <pure-datatable
                                :key="selectedTabIndex"
                                ref="datatable_detailed"
                                endpoint="/api/statistics/consumptions/detailed_view"
                                @data-changed="dataChanged('datatable_detailed')"
                                :queryParams="queryParams"
                                v-slot:default="{ vOn, vBind, isLoading, setLocalOptions, setCurrentOperator, onChangeQueryBuilder }"
                            >
                                <v-data-table id="v_table_detailed_view"
                                    class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table"
                                    :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                    fixed-header
                                    multi-sort
                                    :headers="detailed_view_headers"
                                    :header-props="headerProps"
                                    :hide-default-headers="isMobile"
                                    @update:options="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                    v-on="vOn"
                                    v-bind="vBind"
                                    hide-default-footer
                                    no-data-text="Sem dados disponíveis."
                                    no-results-text="Não foram encontrados resultados."
                                    :loading="isMobile?isLoading:false"
                                    loading-text="A carregar dados..."
                                    :footer-props="{
                                        showFirstLastPage: false,
                                        itemsPerPageOptions: itemsPerPageOptions,
                                        itemsPerPageText: 'Registos por página',
                                    }"
                                >
                                <template v-if="!isMobile" v-for="header in detailed_view_headers" v-slot:[`header.${header.value}`]="{ header }">
                                    <div tabindex="0" :class="isStatisticsLoading?'th-header-l':'th-header'">{{ header.text }}</div>

                                </template>
                                    <template v-if="!isMobile" #[`item.reference`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.reference }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.document_number`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ item.document_number }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.invoice_date`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ formatDate(item.invoice_date) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.designation`]="{ item }">
                                        <div class="datatable-designation-text">
                                            {{ item.designation }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.laboratory_name`]="{ item }">
                                        <div class="d-flex justify-start align-center">
                                            {{ item.laboratory_name }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{  formatQuantity(item.quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.bonus_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.bonus_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.total_quantity`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatQuantity(item.total_quantity) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.net_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.net_total) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.discount`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.discount) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.gross_total`]="{ item }">
                                        <div class="d-flex justify-center align-center">
                                            {{ formatPrice(item.gross_total) }}
                                        </div>
                                    </template>
                                    <template v-if="isMobile" v-slot:item="{ item, index }">
                                        <tr>
                                            <v-card
                                                elevation="2"
                                                >
                                                <v-row>
                                                    <v-col class="d-flex flex-column col pt-0 pb-0">
                                                        <v-row class="d-flex align-start pt-0 pb-0">

                                                            <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                                <v-row class="d-flex align-start pt-0 pb-0">
                                                                    <v-col class="col col-12 pt-0 pb-0 px-0">
                                                                        <div class="pl-0 datatable-designation-text design">
                                                                            {{ item.designation }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                                        <div class="pl-0 datatable-lable-text laboratory">
                                                                            {{ item.laboratory_name}}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-12 pt-0 pb-0 px-0">
                                                                        <div class="pl-0 datatable-lable-text code">
                                                                            {{ item.reference}}
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-row class="d-flex align-start pt-0 pb-0 mt-2">
                                                                <v-col class="col col-6 px-0 pt-0 pb-0 wrap-l">
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">Nº DOC.</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">DATA DOC.</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">SUBTOTAL QTD.</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">SUBTOTAL QTD. BÓNUS</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">TOTAL QTD.</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">VAL. LIQ. COMPRA</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">RAPPEL</v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">TOTAL C/ RAPPEL VALORIZADO</v-col>
                                                                </v-col>
                                                                <v-col class="col col-6  pt-0 pb-0 wrap-r">
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                            <div class="datatable-designation-text">
                                                                                    {{ item.document_series }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                            <div class="datatable-designation-text">
                                                                                    {{ formatDate(item.invoice_date) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                            <div class="datatable-designation-text">
                                                                                    {{ formatQuantity(item.quantity) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatQuantity(item.bonus_total)}}
                                                                        </div>
                                                                    </v-col>

                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatQuantity(item.total_quantity) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatPrice(item.net_total) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatPrice(item.discount) }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                                        <div class="datatable-designation-text">
                                                                                    {{ formatPrice(item.gross_total)}}
                                                                        </div>
                                                                    </v-col>

                                                                </v-col>
                                                            </v-row>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>

                                            </v-card>
                                        </tr>

                                    </template>


                                    <template v-slot:footer="scope">
                                        <div>
                                            <div class="datatable-footer-border"></div>

                                            <data-table-footer
                                                :showExport="canExportDetailed()"
                                                :scope="scope"
                                                @export="exportDetailedData"
                                                @updateOptions="refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, $event)"
                                                :showOrderButton="false"
                                                :isLoading="isLoading"
                                                style="height: fit-content"
                                            ></data-table-footer>
                                        </div>
                                    </template>
                                </v-data-table>
                            </pure-datatable>
                        </template>

                        <template v-else-if="selectedTabIndex === 4">
                            <div class="mt-4 fill-height fill-height-c add-overflow" id="tab_rappel">
                                <div class="fill-height" style="float: left; width: calc(100% - 180px)" v-if="!isMobile">
                                    <area-chart title="Estatísticas de consumos (Rappel)" class="fill-height" curve="straight" :height="'340px'" isPriceChart :series="consumptions"></area-chart>
                                </div>
                                <div style="width: 180px; float: right" v-if="!isMobile">
                                    <div class="d-flex flex-column align-center">
                                        <span class="text-center consumptions-totals-title dark-blue-color">Totais</span>
                                        <div class="mt-7 text-center font-size-md">
                                            <span>Total Valores Período:</span><br />
                                            <span>{{ rappelTotalValue }} </span><br />
                                            <span>Líquido Consumos:</span><br />
                                            <span>{{ rappelTotalNetSum }} </span><br />
                                            <span>Rappel Propec:</span><br />
                                            <span>{{ rappelTotalDiscountSum }} </span><br />
                                        </div>
                                    </div>
                                </div>
                                <div class=""  v-if="isMobile">
                                    <area-chart title="Estatísticas de consumos (Rappel)" :height="isMobile?'520px':'auto'"  class="fill-height" curve="straight" isPriceChart :series="consumptions"></area-chart>
                                        <div class="d-flex flex-column align-center">
                                            <span class="text-center consumptions-totals-title dark-blue-color">Totais</span>
                                            <div class="mt-4 text-center font-size-md">
                                                <span>Total Valores Período:</span><br />
                                                <span>{{ rappelTotalValue }} </span><br />
                                                <span>Líquido Consumos:</span><br />
                                                <span>{{ rappelTotalNetSum }} </span><br />
                                                <span>Rappel Propec:</span><br />
                                                <span>{{ rappelTotalDiscountSum }} </span><br />
                                         </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </app-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import PureDatatable from '@arentia/atools/PureDatatable';
import moment from 'moment';
import { formatIntegerPrice } from '@/Mixins/Formatting';
import { formatQuantity } from '@/Mixins/Formatting';
import ResizeObserver from 'resize-observer-polyfill';
import ProgressChart from '../../Components/Charts/ProgressChart.vue';

// @Note: the chart types are as follows.
const PRICE_CHART_SUFFIX = 'per_price';
const QUANTITY_CHART_SUFFIX = 'per_quantity';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable,
        ProgressChart,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        simplified_view_headers: Array,
        detailed_view_headers: Array,
    },

    data: () => ({
        barWidth:'1000px',
        barLabelWidth:320,
        barStyleWidth:'width:1000px;',
        divwidth:'',
        filters: {},
        queryParams: {},
        currentOperator: 'all',
        hasExpandedActiveFilters: false,
        datatableSize: 200,
        resizeObserver: null,

        timer: null,
        isStatisticsLoading: true,
        isPerformanceLoading: true,
        hasStatisticsLoaded: false,
        hasPerformanceLoaded: false,
        wasPerformanceTabSelected: false,
        itemsPerPageOptions:window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[10,20,50],
        selectedTabIndex: 0,
        tabItems: [{ tab: 'RESUMO DE CONSUMOS' }, { tab: 'DESEMPENHO' }, { tab: 'VISTA SIMPLIFICADA' }, { tab: 'VISTA DETALHADA' }, { tab: 'RAPPEL' }],

        statistics: {
            consumptions: [],
        },

        performance: {
            currentPage: 1,
            lastPage: 1,

            // Top 10
            products_per_price: null,
            products_per_quantity: null,

            laboratories_per_price: null,
            laboratories_per_quantity: null,

            pharma_compositions_per_price: null,
            pharma_compositions_per_quantity: null,

            species_per_price: null,
            species_per_quantity: null,

            active_substances_per_price: null,
            active_substances_per_quantity: null,

            administration_routes_per_price: null,
            administration_routes_per_quantity: null,
        },

        rappelTotalValue: '0 €',
        rappelTotalNetSum: '0 €',
        rappelTotalDiscountSum: '0 €',

        minEndDate: null,
        maxEndDate: null,

        chartNames: ['Produtos', 'Laboratórios', 'Classificação Farmacológica', 'Espécies', 'Substâncias ativas', 'Vias de administração'],
        first:false
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;
               // this.refresh(true);
                if(!this.isMobile){
                    this.refresh(true);
                }else{
                    if(this.first){
                        this.refresh(true);
                    }else{
                        this.getPrefilledBranches()
                    }
                }
            },
            immediate: true,
        },

        selectedTabIndex: {
            handler: function () {
                this.refresh();
            },
            immediate: true,
        },

        hasStatisticsLoaded: {
            handler: function (loaded) {
                if (loaded && !this.wasPerformanceTabSelected) this.getPerformance(true);
            },
        },

        hasPerformanceLoaded: {
            handler: function (loaded) {
                if (loaded && this.wasPerformanceTabSelected) this.getStatistics();
            },
        },
    },

    created() {
        if(this.isMobile){
            this.getPrefilledBranches()
        }else{
            this.applyDefaultFilters();
        }
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
             this.fixChartWidth()
             this.prepareResponsiveBehaviour();
        })
    },
    mounted() {
        this.prepareResponsiveBehaviour();
        //console.log('mounted collapse-categories-card');
        window.EventBus.$emit('collapse-categories-card',true)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        //
        // Charts
        //
        hasStatistics() {
            return Object.keys(this.statistics).some((key) => this.statistics[key].length);
        },

        hasPerformance() {
            return Object.keys(this.performance).some((key) => this.performance[key]?.length);
        },

        showLoading() {
            if (this.selectedTabIndex === 0 || this.selectedTabIndex === 4) return this.isStatisticsLoading;
            if (this.selectedTabIndex === 1) return this.isPerformanceLoading ? true : !this.hasPerformanceLoaded;

            return false;
        },

        activeChartNoData() {
            if (this.selectedTabIndex === 0 || this.selectedTabIndex === 4) {
                return !this.hasStatistics;
            }
            if (this.selectedTabIndex === 1) {
                return !this.hasPerformance;
            }

            return false; // the datatables have their own 'no data' state.
        },

        summary() {
            if (this.statistics.consumptions.length === 0) {
                return [];
            }

            return this.buildChartData(
                new Map([
                    ['Valor Total + Rappel Valorizado', 'gross_sum'],
                    //
                ])
            );
        },

        summaryTotalValue() {
            let total = 0;

            for (const consumption of this.statistics.consumptions) {
                total += parseFloat(consumption.gross_sum);
            }

            return formatIntegerPrice(total);
        },

        consumptions() {
            this.resetTotalRappelValues();

            if (this.statistics.consumptions.length === 0) {
                return [];
            }

            const series = new Map([
                ['Valor Líquido Consumos', 'net_sum'],
                ['Valor Rappel Propec', 'discount_sum'],
            ]);

            const result = this.buildChartData(series);

            this.computeRappelTotalValues(result);

            return result;
        },

        hasMoreChartPages() {
            return this.performance.currentPage < this.performance.lastPage;
        },

        chartName() {
            return this.chartNames[this.performance.currentPage - 1];
        },

        getPriceSeries() {
            return this.getPropertyFromChart('name', 'gross_sum', PRICE_CHART_SUFFIX);
        },
        getChartPriceSeries() {
            return [{ data: this.getPriceSeries }];
        },
        getChartPriceLabels() {
            let lables=[]
            _.each(this.getPriceSeries,(o)=>{
                //console.log(o)
               lables.push(o.x)
            })
            //console.log('labels',lables)
            return lables
        },

        getQuantitySeries() {
            return this.getPropertyFromChart('name', 'total_quantity', QUANTITY_CHART_SUFFIX);
        },
        getChartQuantitySeries() {
            return [{ data: this.getQuantitySeries }];
        },

        isPerformanceTabSelected() {
            return this.selectedTabIndex === 1;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        getPrefilledBranches(){
             axios
                .get('/api/branches/prefilled-branches')
                .then((response) => {
                       let result = response.data
                       this.model['branch__id']=[];
                       for(let field in result){
                          this.model['branch__id'].push({id:result[field].id})
                       }
                       this.applyDefaultFilters();
                       if(!this.first){
                            this.$nextTick(_=>{
                                this.first=true
                                this.refresh(true)
                            })
                       }
                }).catch((error) => {
                    console.log(error);
                });
        },
        fixChartWidth(){
            let width = window.innerWidth
            this.$nextTick(()=>{
                if(width==1366){
                    this.barWidth= '860px'
                    this.barLabelWidth=280
                    this.barStyleWidth='width:860px;'
                    this.divwidth='50vw'
                }else if(width==1024){
                    this.barWidth= '820px'
                    this.barLabelWidth=280
                    this.barStyleWidth='width:820px;'
                    this.divwidth='70vw'
                }else if(width==820){
                    this.barWidth= '620px'
                    this.barLabelWidth=120
                    this.barStyleWidth='width:620px;'
                    this.divwidth='70vw'
                }else if(width==768){
                    this.barWidth= '520px'
                    this.barLabelWidth=120
                    this.barStyleWidth='width:520px;'
                    this.divwidth='70vw'
                }else{
                    this.barWidth= '800px'
                    this.barLabelWidth=320
                    this.barStyleWidth='width:800px;'
                    this.divwidth='50vw'
                }
            })

        },
        dataChanged(targetRef) {
            const wrapper = this.$refs[targetRef]?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        buildChartData(series) {
            const result = [];

            for (const [label, field] of series) {
                result.push({
                    name: label,
                    data: this.statistics.consumptions.map((it) => ({ x: it.date, y: it[field] })),
                });
            }

            return result;
        },

        resetTotalRappelValues() {
            this.rappelTotalNetSum = '0 €';
            this.rappelTotalDiscountSum = '0 €';
            this.rappelTotalValue = '0 €';
        },

        computeRappelTotalValues(consumptions) {
            let total = 0;
            let totalNetSum = 0;
            let totalDiscountSum = 0;

            for (const consumption of consumptions) {
                for (const value of consumption.data) {
                    if (consumption.name == 'Valor Líquido Consumos' || consumption.name == 'Valor Rappel Propec') {
                        total += parseFloat(value.y);
                    }
                    if (consumption.name == 'Valor Líquido Consumos') {
                        totalNetSum += parseFloat(value.y);
                    }
                    if (consumption.name == 'Valor Rappel Propec') {
                        totalDiscountSum += parseFloat(value.y);
                    }
                }
            }

            this.rappelTotalNetSum = formatIntegerPrice(totalNetSum);
            this.rappelTotalDiscountSum = formatIntegerPrice(totalDiscountSum);

            this.rappelTotalValue = formatIntegerPrice(total);
        },

        getPropertyFromChart(label, property, type) {
            const pageIndex = this.performance.currentPage - 1;

            // Get the data for that type of chart, e.g. 'products_per_price'
            const keys = Object.keys(this.performance).filter((it) => it.endsWith(type));
            const key = keys.at(pageIndex);

            // And finally transform the array based on the requested property, e.g. 'products_per_price'
            //  will have a sum of the prices, not a quantity, so we'll request the sum property.
            return this.performance[key]?.filter((it) => it[property] > 0)?.map((it) => ({ x: it[label], y: it[property] }));
        },

        prepareResponsiveBehaviour() {
            this.fixChartWidth()
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 159 - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },

        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            //console.log('onFiltersChanged consumptions',this.isIOS(),hasAutoSearch);
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh(true);
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },
        refresh(forceRequest = false) {
            if (!this.branchStore.branch) return;

            // Check if the start_date and end_date filters are valid (must be within a 1 year interval, will use start_date as the basis for all checks)
            if (this.filters.start_date != null) {
                // Set the limit end date to 1 year starting from the start_date
                this.minEndDate = this.filters.start_date;
                this.maxEndDate = moment(this.filters.start_date).add(1, 'year').format('YYYY-MM-DD');
                this.schema.end_date.minDate = this.minEndDate;
                this.schema.end_date.maxDate = this.maxEndDate;

                // If the other date is set and somehow exceeds the 1 year maximum gap, we'll adjust it accordingly
                if (this.filters.end_date) {
                    // if end date is set and is lower than start date, set a new end date 1 year from the start date
                    const minEndDate = moment(this.filters.start_date).format('YYYY-MM-DD');
                    if (moment(this.filters.end_date) < moment(minEndDate)) this.filters.end_date = moment(this.filters.start_date).add(1, 'year').format('YYYY-MM-DD');

                    // If end date is set and is higher than 1 year after the start date, set it to 1 year from the start date
                    const maxEndDate = moment(this.filters.start_date).add(1, 'year').format('YYYY-MM-DD');
                    if (moment(this.filters.end_date) > moment(maxEndDate)) this.filters.end_date = maxEndDate;
                }
            } else {
                // Clear the limit end date
                this.minEndDate = null;
                this.maxEndDate = null;
                this.schema.end_date.minDate = null;
                this.schema.end_date.maxDate = null;
            }

            if (forceRequest) {
                this.hasStatisticsLoaded = false;
                this.hasPerformanceLoaded = false;

                // Debounce the statistics calls (both datatables already have the debouncing feature built-in).
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                this.timer = setTimeout(() => {
                    this.wasPerformanceTabSelected = this.isPerformanceTabSelected;
                    this.wasPerformanceTabSelected ? this.getPerformance(forceRequest) : this.getStatistics();
                }, 500);
            }

            this.$nextTick(() => {
                if (this.$refs['datatable_simplified']) {
                    this.$refs['datatable_simplified'].setCurrentOperator(this.currentOperator);
                    this.$refs['datatable_simplified'].onChangeQueryBuilder(this.filters, this.schema);
                }
                if (this.$refs['datatable_detailed']) {
                    this.$refs['datatable_detailed'].setCurrentOperator(this.currentOperator);
                    this.$refs['datatable_detailed'].onChangeQueryBuilder(this.filters, this.schema);
                }
            });
        },

        refreshDatatable(onChangeQueryBuilder, setLocalOptions, setCurrentOperator, options) {
            if (options) {
                setLocalOptions(options);
            }

            setCurrentOperator(this.currentOperator);
            onChangeQueryBuilder(this.filters, this.schema);
        },

        getStatistics() {
            const query = buildQueryObjectFromModel(this.filters, this.schema, { operator: this.currentOperator });
            this.isStatisticsLoading = true;

            axios
                .post('/api/statistics/consumptions', {
                    ...this.queryParams,
                    queryObject: JSON.stringify(query),
                    selectedTab: this.tabItems[this.selectedTabIndex].tab,
                })
                .then((response) => {
                    for (const key in this.statistics) {
                        if (response.data[key]) {
                            this.statistics[key] = response.data[key];
                        }
                    }
                })
                .catch((error) => {
                    for (const key in this.statistics) {
                        this.statistics[key] = [];
                    }

                    console.log(error.response);
                    this.showError('Não foi possível carregar os dados pretendidos, por favor tente mais tarde.');
                })
                .finally(() => {
                    this.hasStatisticsLoaded = true;
                    this.isStatisticsLoading = false;
                });
        },

        getPerformance(isForceRequest) {
            const query = buildQueryObjectFromModel(this.filters, this.schema, { operator: this.currentOperator });

            if (isForceRequest) {
                // Reset the performance to the default state, as the cache and pagination are invalid.
                Object.assign(this.$data.performance, this.$options.data.call(this).performance);
            }

            this.isPerformanceLoading = true;

            axios
                .post('/api/statistics/performance', {
                    ...this.queryParams,
                    page: this.performance.currentPage,
                    queryObject: JSON.stringify(query),
                })
                .then((response) => {
                    for (const key in this.performance) {
                        if (response.data[key]) {
                            this.performance[key] = response.data[key];
                        }
                    }
                })
                .catch((error) => {
                    for (const key in this.performance) {
                        this.performance[key] = null;
                    }

                    console.log(error.response);
                    this.showError('Não foi possível carregar os dados pretendidos, por favor tente mais tarde.');
                })
                .finally(() => {
                    this.hasPerformanceLoaded = true;
                    this.isPerformanceLoading = false;
                });
        },

        changePerformancePage(amount) {
            const nextPage = this.performance.currentPage + amount;

            if (nextPage < 1 || nextPage > this.performance.lastPage) {
                return;
            }

            this.performance.currentPage = nextPage;

            // If we have already calculated the values, we'll just return and show the cached versions.
            const isCached = this.getQuantitySeries || this.getPriceSeries;
            if (isCached) return;

            this.getPerformance();
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh(true);
        },

        canExportSimplified() {
            return this.userStore.hasPermissionTo('Export consumptions');
        },

        canExportDetailed() {
            return this.userStore.hasPermissionTo('Export consumptions');
        },

        exportSimplifiedData() {
            if (!this.branchStore.branch || !this.$refs.datatable_simplified) return;

            const axiosSettings = {
                url: '/api/statistics/consumptions/simplified-view/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable_simplified.exportData(axiosSettings, 'export_consumos_simplificados');
        },

        exportDetailedData() {
            if (!this.branchStore.branch || !this.$refs.datatable_detailed) return;

            const axiosSettings = {
                url: '/api/statistics/consumptions/detailed-view/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable_detailed.exportData(axiosSettings, 'export_consumos_detalhados');
        },

        changeCurrentOperator(type) {
            this.currentOperator = type;
            this.refresh(true);
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}

.consumptions-totals-title {
    font-weight: 700 !important;
    cursor: default !important;
}
#v_table_simplified_view.v-data-table{
    line-height: 18px!important;
}
#v_table_simplified_view th{
    text-align: left !important;
}
#v_table_simplified_view th span{
    line-height: 15px!important;
}
#v_table_simplified_view tr td{
    height: 35px!important;
}

#v_table_detailed_view.v-data-table{
    line-height: 18px!important;
}
#v_table_detailed_view th{
    text-align: left !important;
}
/*#v_table_detailed_view th span{
    line-height: 15px!important;
}*/
#v_table_detailed_view tr td{
    height: 35px!important;
}
#statistics #myprovet-tabs .myprovet-tab-item{
   height: 30px;
   letter-spacing: normal;
}
#statistics text.apexcharts-title-text{
  font-size: 0.875rem;
}
#statistics text.apexcharts-text.apexcharts-yaxis-label.apexcharts-xaxis-label{
  font-size: 0.5875rem;
}
#statistics .performance-info{
  line-height: normal;
  margin-top:30px;
}
</style>
